module.exports = __webpack_public_path__ + "static/kartchen-arbeiten-wohnen2-3e3de72667fbb476a68f7985fdd51acb.png";